<template>
  <div class="special-services text-left" v-if="infoSpecialService">
    <div class="special-services__header">
      <h6 class="special-services__header--title">
        <b>Special Service Model</b>
      </h6>
    </div>
    <hr />

    <div class="special-services__elements">
      <span class="special-services__elements--data"
        ><b>Alert: </b
        ><span v-if="infoSpecialService">{{
          infoSpecialService.alert
        }}</span></span
      >
      <span class="special-services__elements--data"
        ><b>Transit Time: </b
        ><span v-if="infoSpecialService">{{
          infoSpecialService.transit_time
        }}</span></span
      >
    </div>
    <div class="carrier-cost__table" v-if="infoSpecialService">
      <b-table responsive :fields="fielsTable" :items="itemsTable">
        <template #cell(details)="data">
          {{ data.cost }}
          <div v-for="(element, index) in fieldDetail" :key="index">
            <span
              ><b>{{ element }}</b>
            </span>
          </div>
        </template>
        <template #cell(cost)="data">
          {{ data.cost }}
          <div v-for="(element, index) in infoSpecialService.cost" :key="index">
            <span>
              {{ !element ? 0 : element }}
            </span>
          </div>
        </template>

        <template #cell(price)="data">
          {{ data.price }}
          <div
            v-for="(element, index) in infoSpecialService.price"
            :key="index"
          >
            <span>
              {{ !element ? 0 : element }}
            </span>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SpecialServicesModel",
  props: {
    tripNumber: Number
  },
  data() {
    return {
      infoHaul: null,
      fielsTable: ["Details", "Cost", "Price"],
      infoSpecialService: null,
      itemsTable: [
        {
          cost: {
            cargo: "",
            large: "",
            small: "",
            sprinter: ""
          }
        }
      ],
      fieldDetail: null
    };
  },
  computed: {
    ...mapGetters("specialServiceModel", ["showSpecialServiceInfo"])
  },
  watch: {
    showSpecialServiceInfo(value) {
      this.infoSpecialService = value;
      this.fieldDetail = Object.keys(this.infoSpecialService.cost);
    }
  },
  methods: {
    onHidden() {
      this.$refs["button-calculate"].focus();
    }
  }
};
</script>

<style scoped lang="scss">
.special-services {
  @include card;
  height: 100%;
  margin-top: 0.5rem;
  hr {
    @include margin-card-hr;
  }
  &__header {
    @include flex-wrap(space-between);
    &--title {
      margin: 0px;
      align-self: center;
    }
  }
  &__elements {
    @include flex-wrap(space-between);
    margin-left: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    &--data {
      margin-top: 5px;
      width: 250px;
    }
  }
  &__table {
    @include card;
    width: 95%;
    display: inline-block;
    margin: 10px;
  }
}
@media (max-width: 767px) {
  .special-services {
    margin-top: 15px;
    &__elements {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
}
</style>
